import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const AddressContainer: React.FC<Props> = ({
    children,
}) => {
    const theme = useTheme();

    const style = css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin-bottom: 10px;

        .address-box {
            position: relative;
        }

        .address-box:nth-of-type(odd)::after {
            content: '';
            position: absolute;
            right: 0;
            top: 10px;
            bottom: 10px;
            width: 1px;
            background-color: ${theme.colours.silver};
        }

        .address-box:nth-of-type(even) {
            padding-left: 30px;
        }

        .address-box:nth-of-type(-n + 2) {
            padding-bottom: 20px;
        }

        .address-box:nth-of-type(n + 3) {
            padding-top: 20px;
        }

        :has(.address-box:nth-of-type(3)) .address-box:nth-of-type(odd):nth-of-type(-n + 2)::before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 20px;
            height: 1px;
            background-color: ${theme.colours.silver};
        }

        :has(.address-box:nth-of-type(3)) .address-box:nth-of-type(even):nth-of-type(-n + 2)::before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 20px;
            right: 0;
            height: 1px;
            background-color: ${theme.colours.silver};
        }

        ${theme.breakpoints.down("xs") } {
            grid-template-columns: 1fr;
            row-gap: 20px;

            .address-box {
                padding: 0 !important;

                &::before, &::after {
                    display: none;
                }
            }
        }
    `;

    return (
        <div css={style}>{children}</div>
    );
}

export default AddressContainer;
